import { Outlet } from 'react-router-dom';

import { NavigateWithParams } from '@spacefill/shared/src/utils/RouterUtils';
import { AppLayout } from '@spacefill/uikit/src/components/AppLayout/AppLayout';
import { Loader } from '@spacefill/uikit/src/components/Loader/Loader';

import { AnnouncementsBanner } from '../../layout/Annoucements/AnnouncementsBanner';
import { AppSidebar } from '../../layout/AppSidebar';
import { SpacefillTopbar } from '../../layout/Topbar';

const Profile = async () =>
    import('../../pages/profile/Edit').then((module) => ({
        Component: module.ProfilePage,
    }));
const CompanyProfileViewPage = async () =>
    import('../../pages/company-profile/CompanyProfileView').then((module) => ({
        Component: module.CompanyProfileView,
    }));

const getUserRoutes = () => {
    return [
        {
            paths: ['/profile/', '/notifications-preferences/'],
            lazy: Profile,
        },
        {
            path: '/company/profile',
            lazy: CompanyProfileViewPage,
            redirectFrom: ['/company-profile'],
        },
        {
            path: '/company/coworkers',
            lazy: CompanyProfileViewPage,
        },
        {
            path: '/notifications-redirecting/',
            element: (
                <AppLayout
                    topbar={<SpacefillTopbar />}
                    leftNav={<AppSidebar />}
                    headerContent={<AnnouncementsBanner />}
                >
                    <Loader />
                    <Outlet />
                </AppLayout>
            ),
        },
        {
            path: '/notifications/',
            element: (
                <NavigateWithParams
                    to={() => {
                        const searchParams = new URLSearchParams(window.location.search);
                        if (searchParams.has('planned_date')) {
                            // notification groupée
                            return '/analytics/?notifications';
                        }
                        return '/notifications-redirecting/?notifications';
                    }}
                />
            ),
            redirectFrom: ['/notifications'],
        },
    ];
};

export { getUserRoutes };
